<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist @help="help" @opentable="opentable" @add="add" @del="del" @search="search" @reflash="reflash" @imp="imp" @exps="exp" @save="save" ref="SetBtn"></buttonlist>
        <!-- 功能按钮 -->
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <div style="margin-top:2px">
                    <el-button type="primary" size="mini" @click="batchAudit" :disabled="!btn.batchaudit">
                        {{$t('getapi[1315]') }}
                    </el-button>
                    <el-button type="primary" size="mini" @click="batchReverseAudit" :disabled="!btn.batchreverseaudit">
                        {{$t('getapi[1316]') }}
                    </el-button>
                </div>
                <!-- 表格 -->
                <el-tabs :tab-position="'top'" type="" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[945]')"  name="0">
                        <wTable
                                id="xpane-0"
                                :data="datajson"
                                :loading="loading"
                                queryData="SALQuotationViewInfo"
                                :filter_language="['Valid_Flag','part_statusname']"
                                :filter_thousandth="['Net_Unit_Price','Unit_Price']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handleSelectionChange"
                                @edits="edits"
                                @rowdblclick="openEdit"
                                ref="singleTable"
                        ></wTable>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[12497]')"  name="1">
                        <wTable
                                id="xpane-1"
                                :data="datajson1"
                                :loading="loading"
                                queryData="SALQuotationViewInfo"
                                :filter_language="['Valid_Flag','part_statusname']"
                                :filter_thousandth="['Net_Unit_Price','Unit_Price']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handleSelectionChange"
                                @edits="edits"
                                @rowdblclick="openEdit"
                                ref="singleTable1"
                        ></wTable>
                    </el-tab-pane>
                </el-tabs>
            </li>

            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <!-- 编辑弹框 -->
                <div class="btnnowrap">
                    <el-button type="primary" size="mini" icon="" @click="handleCommand(1)" :disabled="!btn.Audit">
                        {{$t('getapi[941]')}}
                    </el-button>
                    <el-button type="primary" size="mini" icon="" @click="handleCommand(0)"
                               :disabled="!btn.DeAudit">{{$t('getapi[1334]')}}
                    </el-button>
                </div>
                <div style="width:740px;min-width:740px">
                    <table>
                        <tr>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2652]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <routejump :urlNo="39" v-show="!isEdit">
                                <el-input
                                        class="mcolor"
                                        v-model="formInline.sale_part_code"
                                        :placeholder="$t('getapi[2652]')"
                                        readonly
                                >
                                    <i class="el-icon-edit el-input__icon" slot="suffix" @click="ssf"></i>
                                </el-input>
                                </routejump>
                                <el-input
                                        v-show="isEdit"
                                        class="mcolor"
                                        v-model="formInline.sale_part_code"
                                        :placeholder="$t('getapi[2652]')"
                                        suffix-icon="el-icon-edit"
                                        readonly
                                ></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2653]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-model="formInline.part_name"
                                        :readonly="formInline.valid_flag == 1" :class="[formInline.valid_flag == 1?'readO':'mcolor']"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{$t('getapi[6352]')}}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-model="formInline.cust_version"
                                        :placeholder="$t('getapi[6352]')" :readonly="formInline.valid_flag == 1" :class="[formInline.valid_flag == 1?'readO':'mcolor']"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[2610]') }}</span></td>
                            <td>
                                <routejump :urlNo="31">
                                <el-input class="mcolor" v-model="formInline.customer_code"
                                        :placeholder="$t('getapi[2390]')" readonly>
                                <i class="el-icon-edit el-input__icon" slot="suffix" @click="ccodes"></i>
                            </el-input>
                                </routejump>
                            </td>
                            <td><span>{{ $t('getapi[2390]') }}</span></td>
                            <td><el-input v-model="formInline.customer_part_code"
                                        :readonly="formInline.valid_flag == 1" :class="{'readO':formInline.valid_flag == 1}"></el-input></td>
                            <td><span>{{ $t('getapi[2660]') }}</span></td>
                            <td><el-select filterable v-model="formInline.valid_flag" disabled>
                                <el-option :label="$t('getapi[4048]')" :value="1"></el-option>
                                <el-option :label="$t('getapi[4047]')" :value="0"></el-option>
                            </el-select></td>
                        </tr>
                    </table>
                </div>
                <el-row>
                    <el-col :span="24">
                        <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="100px"
                                 label-position="left" size="small">
                            <el-tabs :style="{ height: tableHeight - 117 + 'px' }">
                                <el-tab-pane :label="$t('getapi[11]')">
                                    <div style="width:740px;min-width:740px">
                                        <table>
                                            <tr>
                                                <td colspan="8"><el-divider content-position="left">{{$t('getapi[11]')}}</el-divider></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[2656]') }}</span></td>
                                                <td><el-input v-model="formInline.sale_type" size="mini" :readonly="true" class="readO"></el-input></td>
                                                <td><span>{{ $t('getapi[3417]') }}</span></td>
                                                <td>
                                                    <routejump :urlNo="35">
                                                    <el-select class="mcolor" filterable v-model="formInline.package_type"
                                                            size="mini" :disabled="formInline.valid_flag == 1">
                                                        <el-option v-for="item in Package" :label="item.TypeName" :value="item.TypeName"
                                                                :key="item.Exclusively_Id"></el-option>
                                                    </el-select>
                                                    </routejump>
                                                </td>
                                                <td><span>{{ $t('getapi[135]') }}</span></td>
                                                <td><el-input v-model="formInline.create_time" size="mini" :readonly="true" class="readO"></el-input></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[2666]') }}</span></td>
                                                <td><el-input v-model="formInline.invpart_code" size="mini" :readonly="true" class="readO"></el-input></td>
                                                <td><span>{{ $t('getapi[2664]') }}</span></td>
                                                <td colspan="3"><el-input v-model="formInline.invpart_name" size="mini" :readonly="true" class="readO"></el-input></td>
                                                <td style="width:80px"><span>{{ $t('getapi[149]') }}</span></td>
                                                <td style="width:120px;min-width:120px"><el-input v-model="formInline.sale_part_version" size="mini"
                                                            :readonly="true" class="readO"></el-input></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[124]') }}</span></td>
                                                <td><el-input v-model="formInline.model" size="mini" :readonly="true" class="readO"></el-input></td>
                                                <td><span>{{ $t('getapi[125]') }}</span></td>
                                                <td><el-input v-model="formInline.spec" size="mini" :readonly="true" class="readO"></el-input></td>
                                                <td><span>{{ $t('getapi[827]') }}</span></td>
                                                <td><el-input v-model="formInline.item_code" size="mini" :readonly="true" class="readO"></el-input></td>
                                                <td><span>{{ $t('getapi[555]') }}</span></td>
                                                <td><el-checkbox  v-model="formInline.isfreeze" :true-label=1 :disabled="btn.isfreeze"
                                                    :false-label=0></el-checkbox></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[1340]') }}</span></td>
                                                <td><el-input v-model="formInline.inv_unit" size="mini"
                                                            :readonly="true" class="readO"></el-input></td>
                                                <td><span>{{ $t('getapi[2658]') }}</span></td>
                                                <td>
                                                    <routejump :urlNo="1">
                                                    <el-select class="mcolor" filterable v-model="formInline.sale_unit"
                                                            size="mini" :disabled="formInline.valid_flag == 1">
                                                    <el-option v-for="item in Inv_Unit" :label="item.Name" :value="item.Name"
                                                            :key="item.Name"></el-option>
                                                </el-select>
                                                    </routejump></td>
                                                <td><span>{{ $t('getapi[1304]') }}</span></td>
                                                <td>
                                                    <el-input v-model="formInline.change_rate" :placeholder="$t('getapi[1304]')"
                                                            size="mini" :readonly="formInline.valid_flag == 1" :class="[formInline.valid_flag == 1?'readO':'mcolor']"></el-input>
                                                </td>
                                                <td><span>{{ $t('getapi[12969]') }}</span></td>
                                                <td>
                                                    <el-input v-model="formInline.customsname" :readonly="true" :placeholder="$t('getapi[12969]')" size="mini"></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[1292]') }}</span></td>
                                                <td><el-input
                                                        v-model="formInline.unit_price"
                                                        :placeholder="$t('getapi[1292]')"
                                                        size="mini"
                                                        :disabled="formInline.valid_flag == 1"
                                                        @input="priinpu"
                                                ></el-input></td>
                                                <td><span>{{ $t('getapi[1352]') }}</span></td>
                                                <td><el-input
                                                        class="mcolor"
                                                        v-model="formInline.net_unit_price"
                                                        :placeholder="$t('getapi[1352]')"
                                                        size="mini"
                                                        :disabled="formInline.valid_flag == 1"
                                                        @input="priinput"
                                                ></el-input></td>
                                                <td><span>{{ $t('getapi[1338]') }}</span></td>
                                                <td>
                                                    <el-input :readonly="true" class="readO" v-model="formInline.currency_code" :placeholder="$t('getapi[1338]')"
                                                            size="mini"></el-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[1225]') }}</span></td>
                                                <td><el-input v-model="formInline.tax_rate" :placeholder="$t('getapi[1225]')" style="width:110px"
                                                            size="mini" :readonly="true" class="readO"></el-input>
                                                    <span>%</span></td>
                                                <td><span>{{ $t('getapi[13429]') }}</span></td>
                                                <td><el-checkbox  v-model="formInline.after_flag" :true-label=1
                                                                  :false-label=0 :disabled="addoredit==1"></el-checkbox></td>
                                            </tr>
                                            <tr>
                                                <td><span>{{ $t('getapi[143]') }}</span></td>
                                                <td colspan="5">
                                                    <el-input v-model="formInline.remark" :placeholder="$t('getapi[143]')"
                                                            size="mini" type="textarea"></el-input>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane :label="$t('getapi[1298]')">
                                    <el-button type="primary" size="mini" icon="el-icon-circle-plus"
                                               @click="addline('')" :disabled="!btn.add">{{$t('getapi[6467]')}}
                                    </el-button>
                                    <el-table
                                            :data="Detail"
                                            v-loading="loading"
                                            :highlight-current-row="false"
                                            show-overflow-tooltip="true"
                                            border
                                            stripe
                                            size="mini"
                                            :height="tableHeight - 150"
                                            header-row-class-name="headerclass"
                                            v-show="!isEdit"
                                            style="margin-top: 3px"
                                    >
                                        <el-table-column prop="batch_floor_limit"
                                                         :label="$t('getapi[1351]')" align="right">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.batch_floor_limit" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                          step="0.0001" onchange="if(value<=0)value=''"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="price" :label="$t('getapi[1292]')"
                                                         align="right">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.price" type="number" autocomplete="off" title="" @mousewheel.native.prevent step="0.0001"
                                                          @change="cahngeprice(scope)"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="net_price"
                                                         :label="$t('getapi[1352]')" align="right">
                                            <template slot-scope="scope">
                                                <el-input v-model="scope.row.net_price" type="number" autocomplete="off" title="" @mousewheel.native.prevent step="0.0001"
                                                          @change="cahngenetprice(scope)"></el-input>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="operate" :label="$t('getapi[6048]')">
                                            <template slot-scope="scope">
                                                <el-button @click.native.prevent="dels(scope)" type="text" size="mini">
                                                    {{ $t('getapi[40]') }}
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <el-table
                                            :data="Detail"
                                            v-loading="loading"
                                            :highlight-current-row="false"
                                            show-overflow-tooltip="true"
                                            border
                                            stripe
                                            size="mini"
                                            :height="tableHeight - 150"
                                            header-row-class-name="headerclass"
                                            v-show="isEdit"
                                            style="margin-top: 3px"
                                    >
                                        <el-table-column prop="batch_floor_limit" :label="$t('getapi[1351]')" align="right">
                                        </el-table-column>
                                        <el-table-column prop="price" :label="$t('getapi[1292]')" align="right"></el-table-column>
                                        <el-table-column prop="net_price" :label="$t('getapi[1352]')" align="right"> </el-table-column>
                                        <!-- <el-table-column prop="operate" :label="$t('getapi[6048]')">
                                            <template slot-scope="scope">
                                                <el-button @click.native.prevent="dels(scope)" type="text" size="mini">
                                                    {{ $t('getapi[40]') }}
                                                </el-button>
                                            </template>
                                        </el-table-column> -->
                                    </el-table>
                                </el-tab-pane>
                            </el-tabs>
                        </el-form>
                    </el-col>
                </el-row>
                <!--<div class="box">
                    <div class="bbl">
                        <span>{{ $t('getapi[2652]') }}</span>
                        <el-input
                                class="mcolor"
                                v-show="!isEdit"
                                v-model="formInline.sale_part_code"
                                :placeholder="$t('getapi[2652]')"
                                style="width: 120px;"
                                readonly
                        >
                            <i class="el-icon-edit el-input__icon" slot="suffix" @click="ssf"></i>
                        </el-input>
                        <el-input
                                style="width: 120px;"
                                v-show="isEdit"
                                class="mcolor"
                                v-model="formInline.sale_part_code"
                                :placeholder="$t('getapi[2652]')"
                                suffix-icon="el-icon-edit"
                                readonly
                        ></el-input>
                        &lt;!&ndash; input 加了readonly属性就不能复制&ndash;&gt;
                        <span>{{ $t('getapi[2653]') }}</span>
                        <el-input style="width: 120px;" v-model="formInline.part_name"
                                  :readonly="formInline.valid_flag == 1" :class="[formInline.valid_flag == 1?'readO':'mcolor']"></el-input>
                        <span>{{$t('getapi[6352]')}}</span>
                        <el-input style="width: 120px;" v-model="formInline.cust_version"
                                  :placeholder="$t('getapi[6352]')" :readonly="formInline.valid_flag == 1" :class="[formInline.valid_flag == 1?'readO':'mcolor']"></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[2610]') }}</span>
                        <el-input class="mcolor" style="width: 120px;" v-model="formInline.customer_code"
                                  :placeholder="$t('getapi[2390]')" readonly>
                            <i class="el-icon-edit el-input__icon" slot="suffix" @click="ccodes"></i>
                        </el-input>
                        <span>{{ $t('getapi[2390]') }}</span>
                        <el-input style="width: 120px;" v-model="formInline.customer_part_code"
                                  :readonly="formInline.valid_flag == 1" :class="{'readO':formInline.valid_flag == 1}"></el-input>
                        <span>{{ $t('getapi[2660]') }}</span>
                        <el-select style="width: 120px;" filterable v-model="formInline.valid_flag" disabled>
                            <el-option :label="$t('getapi[4048]')" :value="1"></el-option>
                            <el-option :label="$t('getapi[4047]')" :value="0"></el-option>
                        </el-select>
                    </div>
                </div>
                <el-divider content-position="left">{{$t('getapi[11]')}}</el-divider>
                <div class="box">
                    <div class="bbl">
                        <span>{{ $t('getapi[2656]') }}</span>
                        <el-input v-model="formInline.sale_type" style="width:120px" size="mini" :readonly="true" class="readO"></el-input>
                        &lt;!&ndash; <el-select class="mcolor" filterable v-model="formInline.sale_type" style="width: 120px;" size="mini">
                            <el-option v-for="item in Sales_Type" :label="item.TypeName" :value="item.TypeName" :key="item.Exclusively_Id"></el-option>
                        </el-select> &ndash;&gt;
                        <span>{{ $t('getapi[3417]') }}</span>
                        <el-select class="mcolor" filterable v-model="formInline.package_type" style="width: 120px;"
                                   size="mini" :disabled="formInline.valid_flag == 1">
                            <el-option v-for="item in Package" :label="item.TypeName" :value="item.TypeName"
                                       :key="item.Exclusively_Id"></el-option>
                        </el-select>
                        <span>{{ $t('getapi[135]') }}</span>
                        <el-input v-model="formInline.create_time" style="width:120px" size="mini" :readonly="true" class="readO"></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[2666]') }}</span>
                        <el-input v-model="formInline.invpart_code" style="width:120px" size="mini" :readonly="true" class="readO"></el-input>
                        <span>{{ $t('getapi[2664]') }}</span>
                        <el-input v-model="formInline.invpart_name" style="width:200px" size="mini" :readonly="true" class="readO"></el-input>
                        <span>{{ $t('getapi[149]') }}</span>
                        <el-input v-model="formInline.sale_part_version" style="width:50px" size="mini"
                                  :readonly="true" class="readO"></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[124]') }}</span>
                        <el-input v-model="formInline.model" style="width:120px" size="mini" :readonly="true" class="readO"></el-input>
                        <span>{{ $t('getapi[125]') }}</span>
                        <el-input v-model="formInline.spec" style="width:120px" size="mini" :readonly="true" class="readO"></el-input>
                        <span>{{ $t('getapi[827]') }}</span>
                        <el-input v-model="formInline.item_code" style="width:120px" size="mini" :readonly="true" class="readO"></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[1340]') }}</span>
                        <el-input v-model="formInline.inv_unit" style="width:120px" size="mini"
                                  :readonly="true" class="readO"></el-input>
                        <span>{{ $t('getapi[2658]') }}</span>
                        &lt;!&ndash; <el-input v-model="formInline.Inv_Unit_Name" :placeholder="$t('getapi[1340]')" style="width:120px" size="mini"></el-input> &ndash;&gt;
                        <el-select class="mcolor" filterable v-model="formInline.sale_unit" style="width: 120px;"
                                   size="mini" :disabled="formInline.valid_flag == 1">
                            <el-option v-for="item in Inv_Unit" :label="item.Name" :value="item.Name"
                                       :key="item.Name"></el-option>
                        </el-select>

                        <span>{{ $t('getapi[1304]') }}</span>
                        <el-input v-model="formInline.change_rate" :placeholder="$t('getapi[1304]')"
                                  style="width:120px" size="mini" :readonly="formInline.valid_flag == 1" :class="[formInline.valid_flag == 1?'readO':'mcolor']"></el-input>
                    </div>
                    <div class="bbl">
                        &lt;!&ndash; 含税价 &ndash;&gt;
                        <span>{{ $t('getapi[1292]') }}</span>
                        <el-input
                                v-model="formInline.unit_price"
                                :placeholder="$t('getapi[1292]')"
                                style="width:120px"
                                size="mini"
                                :disabled="formInline.valid_flag == 1"
                                @input="priinpu"
                        ></el-input>

                        &lt;!&ndash; 不含税价 &ndash;&gt;
                        <span>{{ $t('getapi[1352]') }}</span>
                        <el-input
                                class="mcolor"
                                v-model="formInline.net_unit_price"
                                :placeholder="$t('getapi[1352]')"
                                style="width:120px"
                                size="mini"
                                :disabled="formInline.valid_flag == 1"
                                @input="priinput"
                        ></el-input>
                        <span>{{ $t('getapi[1338]') }}</span>
                        <el-input :readonly="true" class="readO" v-model="formInline.currency_code" :placeholder="$t('getapi[1338]')"
                                  style="width:120px" size="mini"></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[1225]') }}</span>
                        <el-input v-model="formInline.tax_rate" :placeholder="$t('getapi[1225]')" style="width:120px"
                                  size="mini" :readonly="true" class="readO"></el-input>
                        <span>%</span>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[143]') }}</span>
                        <el-input v-model="formInline.remark" :placeholder="$t('getapi[143]')" style="width:350px"
                                  size="mini" type="textarea"></el-input>
                    </div>
                </div>-->
                <!-- <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="110px" label-position="left" size="small">
                    <el-form-item :label="$t('getapi[2652]')" required>
                        <el-input
                            v-show="!isEdit"
                            v-model="formInline.sale_part_code"
                            :placeholder="$t('getapi[2652]')"
                            v-on:click.native="ssf"
                            suffix-icon="el-icon-edit"
                            readonly
                        ></el-input>
                        <el-input v-show="isEdit" v-model="formInline.sale_part_code" :placeholder="$t('getapi[2652]')" suffix-icon="el-icon-edit" readonly></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('getapi[2653]')" required><el-input v-model="formInline.part_name" :placeholder="$t('getapi[2653]')"></el-input></el-form-item>
                    <el-form-item label="订单版本" required><el-input v-model="formInline.cust_version" placeholder="订单版本"></el-input></el-form-item>
                    <el-form-item :label="$t('getapi[2390]')" required><el-input v-model="formInline.customer_code" :placeholder="$t('getapi[2390]')"></el-input></el-form-item>
                    <el-form-item :label="$t('getapi[2391]')" required>
                        <el-input v-model="formInline.customer_part_code" :placeholder="$t('getapi[2391]')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('getapi[2660]')">
                        <el-select filterable v-model="formInline.valid_flag" disabled>
                            <el-option :label="$t('getapi[4048]')" :value="1"></el-option>
                            <el-option :label="$t('getapi[4047]')" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-row>
                    <el-col :span="24">
                        <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="100px" label-position="left" size="small">
                            <el-tabs type="border-card" style="min-height: 300px;">
                                <el-tab-pane :label="$t('getapi[11]')">
                                    <el-row>
                                        <el-col :span="24">
                                            <span>{{ $t('getapi[2656]') }}</label>
                                            <el-select filterable v-model="formInline.sale_type" style="width: 120px;" size="mini">
                                                <el-option v-for="item in Sales_Type" :label="item.TypeName" :value="item.TypeName" :key="item.Exclusively_Id"></el-option>
                                            </el-select>
                                            <span>{{ $t('getapi[3417]') }}</label>
                                            <el-select filterable v-model="formInline.package_type" style="width: 120px;" size="mini">
                                                <el-option v-for="item in Package" :label="item.TypeName" :value="item.TypeName" :key="item.Exclusively_Id"></el-option>
                                            </el-select>
                                            <span>{{ $t('getapi[135]') }}</label>
                                            <el-input v-model="formInline.create_time" :placeholder="$t('getapi[135]')" style="width:120px" size="mini" disabled></el-input>
                                        </el-col>
                                        <el-col :span="24">
                                            <span>{{ $t('getapi[2666]') }}</label>
                                            <el-input v-model="formInline.sale_part_code" :placeholder="$t('getapi[2666]')" style="width:120px" size="mini" disabled></el-input>
                                            <span>{{ $t('getapi[2664]') }}</label>
                                            <el-input v-model="formInline.part_name" :placeholder="$t('getapi[2664]')" style="width:200px" size="mini" disabled></el-input>
                                            <span>{{ $t('getapi[149]') }}</label>
                                            <el-input v-model="formInline.sale_part_version" :placeholder="$t('getapi[149]')" style="width:50px" size="mini" disabled></el-input>
                                        </el-col>
                                        <el-col :span="24">
                                            <span>{{ $t('getapi[124]') }}</label>
                                            <el-input v-model="formInline.model" :placeholder="$t('getapi[124]')" style="width:120px" size="mini"></el-input>
                                            <span>{{ $t('getapi[125]') }}</label>
                                            <el-input v-model="formInline.spec" :placeholder="$t('getapi[125]')" style="width:120px" size="mini"></el-input>
                                            <span>{{ $t('getapi[827]') }}</label>
                                            <el-input v-model="formInline.item_code" :placeholder="$t('getapi[827]')" style="width:120px" size="mini" disabled></el-input>
                                        </el-col>
                                        <el-col :span="24">
                                            <span>{{ $t('getapi[2658]') }}</label>
                                            <el-input v-model="formInline.sale_unit" :placeholder="$t('getapi[2658]')" style="width:120px" size="mini" disabled></el-input>
                                            <span>{{ $t('getapi[1340]') }}</label>
                                            <el-select filterable v-model="formInline.inv_unit" style="width: 120px;" size="mini" :disabled="formInline.valid_flag == 1">
                                                <el-option v-for="item in Inv_Unit" :label="item.Name" :value="item.Name" :key="item.Name"></el-option>
                                            </el-select>

                                            <span>{{ $t('getapi[1304]') }}</label>
                                            <el-input v-model="formInline.change_rate" :placeholder="$t('getapi[1304]')" style="width:120px" size="mini"></el-input>
                                        </el-col>
                                        <el-col :span="24">
                                            <span>{{ $t('getapi[1338]') }}</label>
                                            <el-input v-model="formInline.currency_code" :placeholder="$t('getapi[1338]')" style="width:120px" size="mini"></el-input>

                                            <span>{{ $t('getapi[1292]') }}</label>
                                            <el-input
                                                v-model="formInline.unit_price"
                                                :placeholder="$t('getapi[1292]')"
                                                style="width:120px"
                                                size="mini"
                                                :disabled="formInline.valid_flag == 1"
                                                @input="priinpu"
                                            ></el-input>
                                            <span>{{ $t('getapi[1352]') }}</label>
                                            <el-input
                                                v-model="formInline.net_unit_price"
                                                :placeholder="$t('getapi[1352]')"
                                                style="width:120px"
                                                size="mini"
                                                :disabled="formInline.valid_flag == 1"
                                                @input="priinput"
                                            ></el-input>
                                        </el-col>
                                        <el-col :span="24">
                                            <span>{{ $t('getapi[1225]') }}</label>
                                            <el-input v-model="formInline.tax_rate" :placeholder="$t('getapi[1225]')" style="width:120px" size="mini" disabled></el-input>
                                        </el-col>
                                        <el-col :span="24">
                                            <span>{{ $t('getapi[143]') }}</label>
                                            <el-input v-model="formInline.Remark" :placeholder="$t('getapi[143]')" style="width:350px" size="mini" type="textarea"></el-input>
                                        </el-col>
                                    </el-row>
                                </el-tab-pane>
                            </el-tabs>
                        </el-form>
                    </el-col>
                </el-row>
 -->
                <!-- 编辑弹框 -->
            </li>
        </ul>

        <!-- 分页 -->
        <el-row v-if="tabname == 0" class="page">
            <el-col :span="16">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[50, 100, 200, 300, 400]"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="8">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{ $t('getapi[7980]')
                    }}:{{ DbTbNames }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="tabname == 1" class="page">
            <el-col :span="16">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[50, 100, 200, 300, 400]"
                        :page-size="PageSize1"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1"
                ></el-pagination>
            </el-col>
            <el-col :span="8">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{ $t('getapi[7980]')
                    }}:{{ DbTbNames }}
                </div>
            </el-col>
        </el-row>
        <!-- 分页 -->

        <!-- 搜索弹框 -->
        <serce :isVisible="isVisible" queryData="SALQuotationViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[1021]')" queryData="SALQuotationViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!-- 搜索弹框 -->
        <!-- 销售件弹框 -->
        <!-- <itemtask :isVisible="salssvisi" @getitem="getitem" ref="input"></itemtask> -->
        <selector :isVisible="salssvisi" :isSplitPage=true :postUrl="'/Sal/Price/GetSalPricePartPopupList'"
                  @callback="getitem" ref="input"></selector>
        <selector :isVisible="customercodevisi" :isSplitPage=true :postUrl="'/Basic/Popup/GetSALCustomerDataList'"
                  @callback="callbackFillCode" ref="ccodeselect"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import urlpost from '@/api/config.js';
    import { Loading } from 'element-ui';
    export default {
        name: 'salprice',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight1,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight1,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                Sales_Type: [], //销售类别
                Package: [], //包装方式
                Currency_Unit: [], //货币
                Inv_Unit: [], //库存计量单位
                currate: [], //税率
                currencycode: '',//企业税率代码
                salssvisi: false,
                customercodevisi: false,
                filelist: [],
                ids: '',
                showloading: '',
                isVisible: false,
                editvisi: false,
                isEdit: false,
                addoredit:0,
                CouldEditPrice: false,//销售价格可编辑控制
                DbTbNames: '', //表名
                datajson: [],
                datajson1: [],
                userData:[],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('salprice'),
                PageIndex1: 1,
                PageSize1: this.$http.getPageSize('salprice'),
                SelectIndex: 1,
                total: 0, // 数据总量
                total1: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight1,
                queryData: [], // 查询数组
                currentRow: null,
                formInline: {
                    sale_part_code: '',
                    salpartcode: '',
                    sale_part_version: '',
                    customer_code: '',
                    customer_part_code: '',
                    relation_partmaster_id: 0,
                    sale_type: '',
                    package_type: '',
                    inv_unit: '',
                    sale_unit: '',
                    change_rate: 1,
                    net_unit_price: 0,
                    unit_price: 0,
                    tax_rate: 0,
                    currency_code: '',
                    create_person: '',
                    create_time: '',
                    modify_person: '',
                    modify_time: '',
                    audit_person: '',
                    audit_time: '',
                    valid_flag: 0,
                    remark: '',
                    cust_version: '',
                    salcustversion: '',
                    part_name: '',
                    model: '',
                    spec: '',
                    item_code: '',
                    invpart_code: '',
                    invpart_name: '',
                    invpart_version: '',
                    isfreeze:0,
                    after_flag:0,
                },
                oldFormInline: '',
                btn: {
                    del: false,
                    edit: false,
                    //审核
                    Audit: false,
                    //新增行
                    add: false,
                    //反审
                    DeAudit: false,
                    batchaudit: false,
                    batchreverseaudit: false,
                    isfreeze:false,
                },
                oldrow: '',
                iscontinuedblclick: true,
                selectIDData: '',
                selectData: [],
                timeId: null,
                code: '',
                tabname: 0,
                scrollTop:0,
                scrollTop1:0,
                Detail: [
                    {
                        exclusively_id: 0,
                        part_id: 0,
                        batch_floor_limit: '',
                        price: 0,
                        net_price: 0,
                        relation_id: 0,
                        sale_part_code:'',
                        sale_part_version:'',
                        customer_code:'',
                        remark_discount:'',
                    }
                ],
            };
        },
        create() {
            this.getselect();
        },
        beforeMount() {
            // console.log('beforeMount');
            let that = this;
            that.getselect();
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            // console.log('mounted');
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('salprice', that)
            that.$limits.dragControllerDiv();
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.confirmAdd();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('SALQuotationViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1021]"),this.$t("getapi[14]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (!this.$limits.menuvisible("plv2", 124, 1)) {
                    if (that.$limits.authority('plv2', 123, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 123, 1) == 2) {
                        if (that.$limits.authority('plv3', 123, 1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,import,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 123, 1) == 1) {
                            //编辑级
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,import,export');
                        }
                        if (that.$limits.authority('plv3', 123, 1) == 2) {
                            //删除级
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,import,export');
                        }
                    }
                } else {
                    if (that.$limits.authority('plv2', 124, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 124, 1) == 2) {
                        if (that.$limits.authority('plv3', 124, 1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,import,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 124, 1) == 1) {
                            //编辑级
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,import,export');
                        }
                        if (that.$limits.authority('plv3', 124, 1) == 2) {
                            //删除级
                            that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,import,export');
                        }
                    }
                }
                /*//只读权
                if (that.$limits.ReadOnlyRightsView('plv2', 123, 1, that.total)) {
                    if (that.total > 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                }

                //操作权
                let ilimits = that.$limits.OperationAuthorityView('plv2', 123, 1, that.total);
                console.log('权限' + ilimits);
                // limits说明：、1 查询级、2 编辑权限、3 删除权限
                switch (ilimits) {
                    case -1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case 1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case -2:
                        that.btn.edit = true;
                        that.btn.del = false;
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
                        break;
                    case 2:
                        that.btn.edit = true;
                        that.btn.del = false;
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        break;
                    case -3:
                        that.btn.edit = true;
                        that.btn.del = false;
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
                        break;
                    case 3:
                        that.btn.edit = true;
                        that.btn.del = true;
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        break;
                    default:
                        break;
                }*/
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                that.btn.add = false;
                that.btn.isfreeze=false;
                if (that.$limits.authority('plv4', 589, 1) == 1) {
                    that.btn.isfreeze = false;
                } else {
                    that.btn.isfreeze = true;
                }
                if (that.formInline.valid_flag == 0) {
                    that.isEdit = false;
                    that.btn.add = true;
                }
                else {
                    that.isEdit = true;
                    that.btn.add = false;
                }
                //审核
                that.btn.Audit = false;
                //反审
                that.btn.DeAudit = false;
                //无效
                if (that.formInline.valid_flag == 0) {
                    if (that.$limits.authority('plv4', 304, 1) == 0) {
                        //审核
                        that.btn.Audit = false;
                        //反审
                        that.btn.DeAudit = false;
                    }
                    if (that.$limits.authority('plv4', 304, 1) == 1) {
                        //审核
                        that.btn.Audit = true;
                        //反审
                        that.btn.DeAudit = false;
                    }
                }
                //有效
                if (that.formInline.valid_flag == 1) {
                    if (that.$limits.authority('plv4', 305, 1) == 0) {
                        //审核
                        that.btn.Audit = false;
                        //反审
                        that.btn.DeAudit = false;
                    }
                    if (that.$limits.authority('plv4', 305, 1) == 1) {
                        //审核
                        that.btn.Audit = false;
                        //反审
                        that.btn.DeAudit = true;
                    }
                }

                that.btn.batchaudit = false
                that.btn.batchreverseaudit = false
                if (that.selectData.length > 0) {
                    if (that.$limits.authority('plv4', 304, 1) == 1) {
                        that.btn.batchaudit = that.selectData.every(val => {
                            return val.Valid_Flag == '无效'
                        });
                    }
                    if (that.$limits.authority('plv4', 305, 1) == 1) {
                        that.btn.batchreverseaudit = that.selectData.every(val => {
                            return val.Valid_Flag == '有效'
                        });
                    }
                }
            },
            //新增一行批量价格
            addline(line) {
                let that = this;
                if(line == ''){
                    that.Detail = [...that.Detail,{
                        add: false,
                        exclusively_id:0,
                        p_part_id: 0,
                        batch_floor_limit: 0,
                        price: 0,
                        net_price: 0,
                    }]
                } else {
                    let detail = that.Detail;
                    var index = that.Detail.length - 1;
                    if (!that.$limits.fnIsEmpty(that.Detail[index].price)) {
                        let deti = {
                            add: false,
                            exclusively_id: 0,
                            p_part_id: 0,
                            batch_floor_limit: 0,
                            price: 0,
                            net_price: 0
                        };
                        that.Detail.push(deti);
                        this.isEdit = false;
                    }
                }
            },
            
            //删除行
            dels(e) {
                let that = this;
                if (!that.$limits.fnIsEmpty(e.row._exclusively_id)) {
                    let parm = {
                        exclusively_id: that.exclusively_id,
                        lineid: e.row._exclusively_id,
                    };
                    console.log(parm);
                    that.$http.urlpost('Sal/Part/DeleteBatchPriceByID', parm, function (res) {
                        that.intidata();
                        if (res.Success == 1) {
                            let ppms = {
                                Exclusively_Id: that.exclusively_id,
                            };
                            that.getdetail(ppms);
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    });
                }

            },            
            cahngeprice(data) {
                let that = this;
                let pp = 0;
                this.currate.forEach(item => {
                    if (item.currencycode == this.formInline.currency_code) {
                        pp = item.taxrate / 100;
                        that.currencycode = item.currencycode;
                    }
                });
                if (!that.$limits.fnIsEmpty(that.Detail[data.$index].price)) {
                    if (that.formInline.currency_code != that.currencycode) {
                        that.Detail[data.$index].net_price = (parseFloat(that.Detail[data.$index].price));
                    }
                    else {
                        that.Detail[data.$index].net_price = (that.Detail[data.$index].price / (1 + pp)).toFixed(4);
                    }
                }
            },
            cahngenetprice(data) {
                let that = this;
                let pp = 0;
              
                that.currate.forEach(item => {
                    if (item.currencycode == this.formInline.currency_code) {
                        pp = item.taxrate / 100;
                        that.currencycode = item.currencycode;
                    }
                });                
                if (!that.$limits.fnIsEmpty(that.Detail[data.$index].net_price)) {
                    if (that.formInline.currency_code != that.currencycode) {
                        that.Detail[data.$index].price = (parseFloat(that.Detail[data.$index].net_price));
                    }
                    else {
                        that.Detail[data.$index].price = (that.Detail[data.$index].net_price * (1 + pp)).toFixed(4);
                    }
                }
            },
            //字符转数字
            // PageIndex()
            //获取查询条件
            serclick(val) {
                console.log(val);
                this.queryData = val;
                this.intidata();
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('salprice',val)
                this.intidata();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            //修改页数
            handleSizeChange1(val) {
                this.PageSize1 = val;
                this.$http.savePageSize('salprice',val)
                this.intidata();
                this.authority();
            },
            //跳页
            handleCurrentChange1(val) {
                this.PageIndex1 = val;
                this.intidata();
                this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
                this.authority();
            },
            //获取权限
            getselect() {
                let that = this;
                let parm = {};
                //销售类别
                that.$http.urlpost('Basic/Sale/GetSalTypeList', parm, function (res) {
                    if (res.Success == 1) {
                        console.log(res);
                        that.Sales_Type = res.DataContent;
                        //Sales_Type: [], //销售类别
                    }
                });
                //包装方式
                that.$http.urlpost('Basic/Sale/GetPuckTypeList', parm, function (res) {
                    if (res.Success == 1) {
                        console.log(res);
                        that.Package = res.DataContent;
                        //Package: [], //包装方式
                    }
                });
                //货币
                that.$http.urlpost('Basic/GetCurrencyList', parm, function (res) {
                    if (res.Success == 1) {
                        console.log(res);
                        that.Currency_Unit = res.DataContent;
                        //Currency_Unit:[],//货币
                    }
                });
                //库存计量单位
                that.$http.urlpost('Basic/GetAllUnits', parm, function (res) {
                    if (res.Success == 1) {
                        console.log(res);
                        that.Inv_Unit = res.DataContent;
                        //Inv_Unit:[],//库存计量单位
                    }
                });
                //获取税率
                // "currencycode": "CNY",
                //      "taxrate": "13.0000"
                that.$http.urlpost('Basic/GetCurARate', parm, function (res) {
                    if (res.Success == 1) {
                        // console.log(res);
                        that.currate = res.DataContent;
                    }
                });
            },
            //不含税价--含税价
            priinput(e) {
                //let pp = 0;
                // this.currate.forEach(item => {
                // 	if (item.currencycode == this.formInline.Currency_Unit) {
                // 		pp = item.taxrate / 100;
                // 	}
                // });
                //console.log(pp);
                let that = this;
                let price = e * (1 + that.formInline.tax_rate / 100);
                that.formInline.unit_price = price.toFixed(4);
            },
            //含税价---不含税价
            priinpu(e) {
                let that = this;
                let price = e / (1 + that.formInline.tax_rate / 100);
                that.formInline.net_unit_price = price.toFixed(4);
            },
            // 获取数据
            intidata() {
                let that = this;
                if(that.tabname == 0){
                    that.loading = true;
                    let pm = {
                        query_Condition: '',
                        query_field_type: '',
                        query_field_name: '',
                        row_sign: '',
                        query_sort: ''
                    };
                    let parm = {
                        PageIndex: that.PageIndex,
                        PageSize: that.PageSize,
                        SelectIndex: that.SelectIndex,
                        Param: []
                    };
                    that.queryData.forEach(item => {
                        pm = {
                            row_sign: item.row_sign,
                            query_Condition: item.query_Condition,
                            query_sort: item.query_sort,
                            query_field_type: item.Query_Field_Type,
                            query_field_name: item.Query_Field_Name
                        };
                        parm.Param.push(pm);
                    });
                    that.$http.urlpost('Sal/Price/GetSalPriceList', parm, function (res) {
                        if (res.Success == 1) {
                            that.datajson = res.DataContent;
                            that.total = res.Totals;
                            that.DbTbNames = res.DbTbNames;
                        }
                        that.loading = false;
                        that.authority();
                    });
                } else if(that.tabname == 1) {
                    that.loading = true;
                    let pm = {
                        query_Condition: '',
                        query_field_type: '',
                        query_field_name: '',
                        row_sign: '',
                        query_sort: ''
                    };
                    let parm = {
                        PageIndex: that.PageIndex1,
                        PageSize: that.PageSize1,
                        SelectIndex: that.SelectIndex,
                        Param: []
                    };
                    that.queryData.forEach(item => {
                        pm = {
                            row_sign: item.row_sign,
                            query_Condition: item.query_Condition,
                            query_sort: item.query_sort,
                            query_field_type: item.Query_Field_Type,
                            query_field_name: item.Query_Field_Name
                        };
                        parm.Param.push(pm);
                    });
                    that.$http.urlpost('/Sal/Price/GetSalPriceWaitCloseList', parm, function (res) {
                        if (res.Success == 1) {
                            that.datajson1 = res.DataContent;
                            that.total1 = res.Totals;
                            that.DbTbNames = res.DbTbNames;
                        }
                        that.loading = false;
                        that.authority();
                    });
                }

            },
            // 获取详情 刷右边
            getdetail(item) {
                let that = this;
                that.Detail = [];
                let parm = {
                    sale_part_code: item.Sale_Part_Code,
                    sale_part_version: item.Sale_Part_Version,
                    customer_code: item.Customer_Code,
                    after_flag:(item.after_flag == 'Y' || item.after_flag==1)?1:0,
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('Sal/Price/GetSalPriceInfo', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.formInline = res.DataContent.Head;
                        that.Detail = res.DataContent.Lists;
                        that.formInline.salpartcode = that.formInline.sale_part_code;
                        that.oldFormInline = JSON.stringify(that.formInline)
                        that.authority(2);
                    }
                    loadingInstance.close()
                });
                that.editvisi = true;
            },
            // 编辑
            edit(jsd) {
                // console.log(jsd);
                this.formInline = jsd.row;
                this.formInline.insert_flag = false;
                this.isEdit = true;
                this.addoredit = 1;
                this.getdetail(jsd.row);
            },
            edits(jsd) {
                let that = this;
                if(that.code == jsd.Sale_Part_Code + jsd.Sale_Part_Version + jsd.Customer_Code + jsd.after_flag){
                    return
                }
                that.timeId = setTimeout(() => {
                    if (!this.$limits.menuvisible("plv2", 124, 1)) {
                        return
                    }
                    if (that.oldFormInline != JSON.stringify(that.formInline)) {
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.code = jsd.Sale_Part_Code + jsd.Sale_Part_Version + jsd.Customer_Code + jsd.after_flag
                                that.oldrow = jsd
                                this.formInline = jsd;
                                this.formInline.insert_flag = false;
                                this.isEdit = true;
                                this.addoredit = 1;
                                this.getdetail(jsd);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.code = jsd.Sale_Part_Code + jsd.Sale_Part_Version + jsd.Customer_Code + jsd.after_flag
                        that.oldrow = jsd
                        this.formInline = jsd;
                        this.formInline.insert_flag = false;
                        this.isEdit = true;
                        this.addoredit = 1;
                        this.getdetail(jsd);
                    }
                }, 100);
            },
            // 新增
            add() {
                let that = this;
                if (that.oldFormInline != JSON.stringify(that.formInline)) {
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd() {
                let that = this;
                this.formInline = {
                    sale_part_code: '',
                    salpartcode: '',
                    sale_part_version: '',
                    customer_code: '',
                    customer_part_code: '',
                    relation_partmaster_id: 0,
                    sale_type: '',
                    package_type: '',
                    inv_unit: '',
                    sale_unit: '',
                    change_rate: 1,
                    net_unit_price: '',
                    unit_price: '',
                    tax_rate: '',
                    currency_code: '',
                    create_person: '',
                    create_time: '',
                    modify_person: '',
                    modify_time: '',
                    audit_person: '',
                    audit_time: '',
                    valid_flag: 0,
                    remark: '',
                    cust_version: '',
                    salcustversion: '',
                    part_name: '',
                    model: '',
                    spec: '',
                    item_code: '',
                    invpart_code: '',
                    invpart_name: '',
                    invpart_version: '',
                    isfreeze:0,
                    after_flag:0,
                };
                that.code = ''
                this.Detail = [
                    // {
                    //     exclusively_id: 0,
                    //     p_part_id: 0,
                    //     batch_floor_limit: 0,
                    //     price: 0,
                    //     net_price: 0,
                    //     relation_id: 0
                    // }
                ];
                this.editvisi = true;
                this.isEdit = false;
                this.addoredit = 0;
                this.CouldEditPrice = false;
                that.oldFormInline = JSON.stringify(that.formInline)
                //this.flagshow('常规销售');
            },
            // 获取查询条件
            // getqwlist() {
            // 	let that = this;
            // 	that.$http.urlpost('Basic/Items/WorkCenterQWList', {}, function(res) {
            // 		that.queryData = res.DataContent;
            // 	});
            // },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                that.selectData = []
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].Exclusively_Id + ',';
                    that.selectData.push(val[i])
                }
                // console.log(that.selectIDData);
                that.btnauthority()
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'SALQuotationViewInfo');
            },
            // 刷新
            reflash() {
                /*let that =this;
                that.intidata();
                //刷右边
                if(!that.$limits.fnIsEmpty(that.formInline.sale_part_code)){
                let item = {
                Sale_Part_Code: that.formInline.sale_part_code,
                Sale_Part_Version: that.formInline.sale_part_version,
                Customer_Code: that.formInline.customer_code
                }
                that.getdetail(item);
                }else{
                //清空右边
                that.add();
                }*/
                let that = this;
                if (that.oldFormInline != JSON.stringify(that.formInline)) {
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.intidata();
                            //刷右边
                            if (!that.$limits.fnIsEmpty(that.formInline.sale_part_code)) {
                                let item = {
                                    Sale_Part_Code: that.formInline.sale_part_code,
                                    Sale_Part_Version: that.formInline.sale_part_version,
                                    Customer_Code: that.formInline.customer_code,
                                    after_flag:that.formInline.after_flag,
                                }
                                that.getdetail(item);
                            } else {
                                //清空右边
                                that.confirmAdd();
                            }
                        });
                } else {
                    that.intidata();
                    //刷右边
                    if (!that.$limits.fnIsEmpty(that.formInline.sale_part_code)) {
                        let item = {
                            Sale_Part_Code: that.formInline.sale_part_code,
                            Sale_Part_Version: that.formInline.sale_part_version,
                            Customer_Code: that.formInline.customer_code,
                            after_flag:that.formInline.after_flag,
                        }
                        that.getdetail(item);
                    } else {
                        //清空右边
                        that.confirmAdd();
                    }
                }
            },
            //打开税收商品弹框
            ssf() {
                this.salssvisi = true;
                this.$refs.input.clearInput(this.salssvisi);
            },
            //打开税客户代码选择框
            ccodes() {
                this.customercodevisi = true;
                this.$refs.ccodeselect.clearInput(this.customercodevisi);
            },
            callbackFillCode(data) {
                let that = this;
                that.formInline.customer_code = data.customer_id;
                if (that.formInline.customer_code != '') {
                    that.CouldEditPrice = true;
                    if (that.formInline.tax_rate != data.tax_rate) {//税率有变化，重新计算
                        //含税价->计算不含税价
                        that.formInline.tax_rate = data.tax_rate;
                        let price = that.formInline.unit_price / (1 + that.formInline.tax_rate / 100);
                        that.formInline.net_unit_price = price.toFixed(4);
                    }
                } else {
                    that.CouldEditPrice = false;
                }
                that.formInline.currency_code = data.currency_code_id;

            },
            //获取物料信息
            getitem(val) {
                console.log(val);
                let that = this;
                //that.formInline.Part_No = val.Exclusively_ID;
                that.formInline.relation_partmaster_id = val.part_no;
                that.formInline.sale_part_code = val.sales_part;
                that.formInline.part_name = val.part_name;
                that.formInline.cust_version = val.part_version;
                that.formInline.model = val.model;
                that.formInline.spec = val.spec;
                that.formInline.item_code = val.item_code;
                that.formInline.sale_part_version = val.part_version;
                that.formInline.package_type = val.typename1;//包装方式
                that.formInline.sale_type = val.typename;
                that.formInline.inv_unit = val.part_master_unit;//库存计量单位
                that.formInline.sale_unit = that.formInline.inv_unit;//销售计量单位默认=库存计量单位
                that.formInline.change_rate = val.master_assist_rate;//换算率
                that.formInline.customsname = val.customsname;//报关品名

            },
            // 保存数据
            save() {
                let that = this;
                let parm = {
                    Head: '',
                    Lists: []
                };
                parm.Head = that.formInline;
                parm.Head.LangType = that.$processdata.getLang()
                for(let i = 0;i<that.Detail.length;i++){
                    that.Detail[i].after_flag = that.formInline.after_flag
                }
                parm.Lists=that.Detail;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.loading = true;
                console.log(parm);
                that.$http.urlpost('Sal/Price/SaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.intidata();//刷左边
                        let item = {
                            Sale_Part_Code: that.formInline.sale_part_code,
                            Sale_Part_Version: that.formInline.sale_part_version,
                            Customer_Code: that.formInline.customer_code,
                            after_flag:that.formInline.after_flag,
                        }
                        that.getdetail(item);//刷右边
                        that.loading = false;
                        that.editvisi = false;
                    } else {
                        that.loading = false;
                    }
                });
                that.$refs.SetBtn.SetOneBtnEnable('save', true);
            },
            //删除数据
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            sale_part_code: that.formInline.sale_part_code,
                            sale_part_version: that.formInline.sale_part_version,
                            customer_code: that.formInline.customer_code,
                            valid_flag: that.formInline.valid_flag,
                            after_flag:that.formInline.after_flag,
                        }
                        that.$http.urlpost('Sal/Price/DeleteSalPrice', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.intidata()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 操作
            handleCommand(key) {
                let that = this;
                let parm = {
                    sale_part_code: that.formInline.sale_part_code,
                    sale_part_version: that.formInline.sale_part_version,
                    customer_code: that.formInline.customer_code,
                    valid_flag: that.formInline.valid_flag,
                    after_flag:that.formInline.after_flag,
                }

                if (key == 1) {
                    that.$http.urlpost('Sal/Price/AuditSalPrice', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.intidata();
                            if (!that.$limits.fnIsEmpty(that.formInline.sale_part_code)) {
                                let item = {
                                    Sale_Part_Code: that.formInline.sale_part_code,
                                    Sale_Part_Version: that.formInline.sale_part_version,
                                    Customer_Code: that.formInline.customer_code,
                                    after_flag:that.formInline.after_flag,
                                }
                                that.getdetail(item);
                            } else {
                                //清空右边
                                that.confirmAdd();
                            }
                            that.formInline.valid_flag = key;
                        }
                    });
                } else {
                    that.$http.urlpost('Sal/Price/UnAuditSalPrice', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.intidata();
                            if (!that.$limits.fnIsEmpty(that.formInline.sale_part_code)) {
                                let item = {
                                    Sale_Part_Code: that.formInline.sale_part_code,
                                    Sale_Part_Version: that.formInline.sale_part_version,
                                    Customer_Code: that.formInline.customer_code,
                                    after_flag:that.formInline.after_flag,
                                }
                                that.getdetail(item);
                            } else {
                                //清空右边
                                that.confirmAdd();
                            }
                            that.formInline.valid_flag = key;
                        }
                    });
                }


                // this.formInline.valid_flag = key;
            },
            imp() {
                let item = {
                    //label: '销售件导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/49',
                    url: '/exp/49',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/49'});
                this.$store.commit('selectMenu', item);
            },
            //导出·
            exp() {
                /*let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: that.selectIDData,
                    Param: []
                };
                that.queryData.forEach(item => {
                    //if(item.query_Condition==''||item.query_Condition.length>0) {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                    //}
                });
                console.log(parm);
                that.$http.urlpost('Sal/Price/GetSalPriceListToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    } else {
                        that.$message.error(res.Msg);
                    }
                    that.loading = false;
                });*/
                let that = this;
                if(that.tabname == 0){
                    let datac = [];
                    for (let i = 0; i < that.queryData.length; i++) {
                        datac.push({
                            query_Condition: that.queryData[i].query_Condition,
                            query_field_type: that.queryData[i].Query_Field_Type,
                            query_field_name: that.queryData[i].Query_Field_Name,
                            query_sort: that.queryData[i].query_sort,
                            row_sign: that.queryData[i].row_sign
                        });
                    }
                    let parm = {
                        query_sign: "SALQuotationViewInfo",
                        fromname: that.$t('getapi[1021]'),
                        SelectIndex: 0,
                        MultyVer: that.$processdata.getLanguage(),
                        Param: datac
                    };
                    that.$processdata.commonExport(parm)
                } else if(that.tabname == 1){
                    that.loading = true;
                    let pm = {
                        query_Condition: '',
                        query_field_type: '',
                        query_field_name: '',
                        row_sign: '',
                        query_sort: ''
                    };
                    let parm = {
                        PageIndex: that.PageIndex1,
                        PageSize: that.PageSize1,
                        SelectIndex: that.SelectIndex,
                        Ids: that.selectIDData,
                        Param: []
                    };
                    that.queryData.forEach(item => {
                        pm = {
                            row_sign: item.row_sign,
                            query_Condition: item.query_Condition,
                            query_sort: item.query_sort,
                            query_field_type: item.Query_Field_Type,
                            query_field_name: item.Query_Field_Name
                        };
                        parm.Param.push(pm);
                    });
                    that.$http.urlpost('/Sal/Price/GetSalPriceWaitCloseListToExecl', parm, function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        } else {
                            that.$message.error(res.Msg);
                        }
                        that.loading = false;
                    });
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            show(ev, row) {
                let that = this;
                that.edit(row);
            },
            shows(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = this.datajson[index - 1];
                    this.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = this.datajson[index + 1];
                    this.setCurrent(tds);
                }
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                if (val != null) {
                    console.log(val, this.datajson);
                    let result = this.datajson.findIndex(item => item.Sale_Part_Code === val.Sale_Part_Code);
                    //this.indf = result;

                    let fsd = document.getElementsByClassName('fsd');
                    fsd[result].focus();
                    this.currentRow = val;
                }
            },
            // 批量审核
            batchAudit(val) {
                let that = this
                let arr = []
                for (let i = 0; i < that.selectData.length; i++) {
                    arr = [...arr, {
                        sale_part_code: that.selectData[i].Sale_Part_Code,
                        sale_part_version: that.selectData[i].Sale_Part_Version,
                        customer_code: that.selectData[i].Customer_Code,
                        after_flag:that.selectData[i].after_flag == 'Y'?1:0,
                    }]
                }
                let parm = {
                    auditflag: 1,
                    Lists: arr,
                }
                that.$http.urlpost('/Sal/Price/BatchAuditSALQuotation', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata()
                    }
                });
            },
            // 批量反审核
            batchReverseAudit() {
                let that = this
                let arr = []
                for (let i = 0; i < that.selectData.length; i++) {
                    arr = [...arr, {
                        sale_part_code: that.selectData[i].Sale_Part_Code,
                        sale_part_version: that.selectData[i].Sale_Part_Version,
                        customer_code: that.selectData[i].Customer_Code,
                        after_flag:that.selectData[i].after_flag == 'Y'?1:0,
                    }]
                }
                let parm = {
                    auditflag: 0,
                    Lists: arr,
                }
                that.$http.urlpost('/Sal/Price/BatchAuditSALQuotation', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.intidata()
                    }
                });
            },
            selectInfo(tab, event) {
                let that = this;
                that.tabname = tab.name;
                if(tab.name == 0){
                    this.$refs.singleTable1.$refs.singleTable.clearSelection()
                } else{
                    this.$refs.singleTable.$refs.singleTable.clearSelection()
                }
                that.authority()
            },
            checkDataChange() {
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 124,1) < 1){
                    return false
                }
                let flag = that.oldFormInline != JSON.stringify(that.formInline)
                return flag
            },

        }
    };
</script>

<style lang="scss" scoped>
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        .bbl {
            margin: 0px auto 10px;
            white-space: pre;
            span {
                margin-left: 20px;
                min-width: 70px;
                text-align: left;
                line-height: 20px;
                display: inline-block;
                margin-right: 5px;
            }
        }
    }
</style>
